import { DefaultHttpClient } from "../../core/api/HttpClient.js";
import type { LogRole } from "../../core/types.js";

export type BulkRolePermissionChange = {
    roleId: string;
    name: string;
    before: string;
    after: string;
};

export type BulkRolePermissionSkip = {
    roleId: string;
    reason: string;
};

export type BulkRolePermissionResponse = {
    changes: BulkRolePermissionChange[];
    skipped: BulkRolePermissionSkip[];
};

export function listGuildRoles(signal?: AbortSignal) {
    return DefaultHttpClient.json<LogRole[]>("/api/roles", { signal });
}

export function updateRolePermissions(input: { roleIds: string[]; permissions: string; signal?: AbortSignal }) {
    return DefaultHttpClient.json<BulkRolePermissionResponse>("/api/tools/role-permissions", {
        method: "PATCH",
        body: {
            roleIds: input.roleIds,
            permissions: input.permissions,
        },
        signal: input.signal,
    });
}
